import React, { useEffect, useState } from 'react'
import Switch from 'react-switch'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { useFormUtils } from 'views/shared/useFormUtils'
import Select from 'react-select'
import { milkTypeOptions, flavorOptions, typeOptions } from './constants'
import { isNotAlpha, isNotNumericDecimal } from 'context/Utilities'
import PropTypes from 'prop-types'

const SoyBeveragePackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    MilkType: item.MilkType,
    OtherMilkType: item.OtherMilkType,
    Flavor: item.Flavor,
    Type: item.Type,
    Size: item.Size,
    Organic: item.Organic,
    MultiPackageType: item.MultiPackageType,
    MultiPackageCount: item.MultiPackageCount,
  })
  const methods = useFormContext()
  const {
    onChangeReviewer,
    setSelectReviewer,
    setSwitchReviewer,
    asterisk,
  } = useFormUtils()
  useEffect(() => {
    if (item) {
      const {
        MilkType,
        OtherMilkType,
        Flavor,
        Type,
        Size,
        Organic,
        MultiPackageType,
        MultiPackageCount,
      } = item
      setPackaging({
        MilkType,
        OtherMilkType,
        Flavor,
        Type,
        Size,
        Organic: Organic || false,
        MultiPackageType: MultiPackageType || false,
        MultiPackageCount,
      })
    }
    // eslint-disable-next-line
  }, [item])

  return (
    <Row>
      <Col xs={4}>
        <FormGroup>
          <p>
            <strong>Plant-Based Milk Alternative Type {asterisk}</strong>
          </p>
          <Controller
            as={Select}
            className="react-select primary"
            classNamePrefix="react-select"
            options={milkTypeOptions}
            defaultValue={{
              label: packaging.MilkType,
              value: packaging.MilkType,
            }}
            name="MilkType"
            control={methods.control}
            rules={{ required: true }}
            placeholder={'Select Plant-Based Milk Alternative Type'}
            onChange={([selected, value]) => {
              setSelectReviewer(item, selected, value)
              item.fkCategory = selected.category
              item.fkSubCategory = selected.subCategory
              item.IsBroadband = selected.isBroadband
              setPackaging({ ...packaging, MilkType: selected.value })
              return selected
            }}
            isDisabled={isDisabled}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="MilkType"
              message={'⚠ Please select a Plant-Based Milk Alternative Type.'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
        {packaging.MilkType === 'Other' && (
          <>
            <br />
            <FormGroup>
              <p>
                <strong>
                  Other Plant-Based Milk Alternative Type {asterisk}
                </strong>
              </p>
              <Controller
                as={Input}
                name="OtherMilkType"
                placeholder={'Other Plant-Based Milk Alternative Type'}
                defaultValue={packaging.OtherMilkType}
                onKeyDown={e => {
                  if (isNotAlpha(e.key) && e.key !== ' ') {
                    e.preventDefault()
                  }
                }}
                control={methods.control}
                rules={{
                  required: {
                    value: true,
                    message:
                      '⚠ Other Plant-Based Milk Alternative Type is required.',
                  },
                  maxLength: {
                    value: 30,
                    message:
                      '⚠ Other Plant-Based Milk Alternative Type exceeds 30 characters. ',
                  },
                }}
                onChange={([event]) => {
                  onChangeReviewer(item, event)
                  return event
                }}
                disabled={isDisabled}
              />
              <p className={'text-danger'}>
                <ErrorMessage
                  errors={methods.errors}
                  name="OtherMilkType"
                  as={<Alert color={'danger'} className={'mt-3'} />}
                />
              </p>
            </FormGroup>
          </>
        )}
        <FormGroup>
          <p>
            <strong>Size of Individual Package {asterisk}</strong>
          </p>
          <Controller
            as={Input}
            name="Size"
            type="number"
            step="0.01"
            placeholder={'ounces'}
            defaultValue={packaging.Size}
            onKeyDown={e => {
              if (isNotNumericDecimal(e.key)) {
                e.preventDefault()
              }
            }}
            control={methods.control}
            rules={{
              maxLength: {
                value: 6,
                message: '⚠ Size exceeds 6 characters.',
              },
              required: {
                value: true,
                message: '⚠ Please enter product size.',
              },
              pattern: {
                value: /^\d+(\.\d{1,2})?$/,
                message: '⚠ Maximum two decimal places allowed.',
              },
            }}
            onChange={([event]) => {
              onChangeReviewer(item, event)
              return event
            }}
            disabled={isDisabled}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="Size"
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
      </Col>
      <Col xs={4}>
        <FormGroup>
          <p>
            <strong>Flavor {asterisk}</strong>
          </p>
          <Controller
            as={Select}
            className="react-select primary"
            classNamePrefix="react-select"
            options={flavorOptions}
            defaultValue={{
              label: packaging.Flavor,
              value: packaging.Flavor,
            }}
            name="Flavor"
            control={methods.control}
            rules={{ required: true }}
            placeholder={'Select Flavor'}
            onChange={([selected, value]) => {
              setSelectReviewer(item, selected, value)
              return selected
            }}
            isDisabled={isDisabled}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="Flavor"
              message={'⚠ Please select a flavor.'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
        <br />
        <FormGroup>
          <p>
            <strong>Type {asterisk}</strong>
          </p>
          <Controller
            as={Select}
            className="react-select primary"
            classNamePrefix="react-select"
            name="Type"
            placeholder={'Select Type'}
            options={typeOptions}
            defaultValue={{
              label: packaging.Type,
              value: packaging.Type,
            }}
            onChange={([selected, value]) => {
              setSelectReviewer(item, selected, value)
              return selected
            }}
            control={methods.control}
            rules={{ required: true }}
            isDisabled={isDisabled}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="Type"
              message={'⚠ Please select a type.'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
      </Col>
      <Col xs={4}>
        <FormGroup>
          <p>
            <strong>Organic</strong>
          </p>
          <Controller
            as={Switch}
            name="Organic"
            id="Organic"
            defaultValue={packaging.Organic}
            onChange={([checked, event, id]) => {
              setSwitchReviewer(item, checked, event, id)
              return checked
            }}
            control={methods.control}
            disabled={isDisabled}
          />
        </FormGroup>
        <br />
        <FormGroup>
          <p>
            <strong>Multi-pack</strong>
          </p>
          <Controller
            as={Switch}
            name="MultiPackageType"
            id="MultiPackageType"
            onChange={([checked, event, id]) => {
              setSwitchReviewer(item, checked, event, id)
              setPackaging({
                ...packaging,
                MultiPackageType: checked,
              })
              return checked
            }}
            control={methods.control}
            defaultValue={packaging.MultiPackageType}
            disabled={isDisabled}
          />
        </FormGroup>
        <br />
        {packaging.MultiPackageType === true && (
          <FormGroup>
            <p>
              <strong>Multi-pack Count {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              name="MultiPackageCount"
              placeholder={'Multi-pack Count'}
              defaultValue={packaging.MultiPackageCount}
              onKeyDown={e => {
                if (
                  ![
                    'Backspace',
                    'Delete',
                    'Tab',
                    'ArrowLeft',
                    'ArrowRight',
                  ].includes(e.key) &&
                  isNaN(parseInt(e.key))
                ) {
                  e.preventDefault()
                }
              }}
              control={methods.control}
              rules={{
                maxLength: { value: 2, message: '⚠ 2 characters max.' },
                required: {
                  value: true,
                  message: '⚠ Multi Pack Count is required.',
                },
              }}
              onChange={([event]) => {
                onChangeReviewer(item, event)
                return event
              }}
              disabled={isDisabled}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="MultiPackageCount"
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        )}
      </Col>
    </Row>
  )
}

SoyBeveragePackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default SoyBeveragePackageReview
